import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class DealsStackComponent extends Component {
  requiredRefs = ['stack'];
  #cards = [];
  #start = null;

  connectedCallback() {
    super.connectedCallback();
    this.#setup();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#cards.forEach((c) => {
      c.removeEventListener('pointerdown', this.#onDown);
    });
  }

  #setup() {
    const { stack } = this.refs;
    if (!stack) return;
    this.#cards = Array.from(stack.querySelectorAll('.ds__card'));
    this.#layCards();
    if (!prefersReducedMotion()) {
      this.#cards.forEach((card) => {
        card.addEventListener('pointerdown', this.#onDown);
        card.style.cursor = 'grab';
      });
    }
  }

  #layCards() {
    this.#cards.forEach((card, i) => {
      const depth = this.#cards.length - 1 - i;
      card.style.setProperty('--depth', depth);
      card.style.zIndex = i + 1;
    });
  }

  #onDown = (e) => {
    const card = e.currentTarget;
    card.setPointerCapture(e.pointerId);
    card.style.cursor = 'grabbing';
    this.#start = { x: e.clientX, card };
    card.addEventListener('pointermove', this.#onMove);
    card.addEventListener('pointerup', this.#onUp, { once: true });
    card.addEventListener('pointercancel', this.#onCancel, { once: true });
  };

  #onMove = (e) => {
    if (!this.#start) return;
    const dx = e.clientX - this.#start.x;
    const rot = dx / 18;
    this.#start.card.style.setProperty('--dx', dx + 'px');
    this.#start.card.style.setProperty('--rot', rot + 'deg');
  };

  #onUp = (e) => {
    if (!this.#start) return;
    const { card } = this.#start;
    card.removeEventListener('pointermove', this.#onMove);
    card.style.cursor = 'grab';
    const dx = e.clientX - this.#start.x;
    this.#start = null;
    if (Math.abs(dx) > 110) {
      this.#dismiss(card, dx > 0 ? 1 : -1);
    } else {
      card.style.setProperty('--dx', '0px');
      card.style.setProperty('--rot', '0deg');
    }
  };

  #onCancel = () => {
    if (!this.#start) return;
    const { card } = this.#start;
    card.removeEventListener('pointermove', this.#onMove);
    card.style.setProperty('--dx', '0px');
    card.style.setProperty('--rot', '0deg');
    this.#start = null;
  };

  #dismiss(card, dir) {
    card.classList.add('ds__card--flying');
    card.style.setProperty('--fly', dir * 140 + 'vw');
    setTimeout(() => {
      card.classList.remove('ds__card--flying');
      card.style.removeProperty('--dx');
      card.style.removeProperty('--rot');
      card.style.removeProperty('--fly');
      const { stack } = this.refs;
      if (stack) stack.prepend(card);
      this.#cards = Array.from(stack.querySelectorAll('.ds__card'));
      this.#layCards();
    }, 420);
  }
}

if (!customElements.get('deals-stack-component')) {
  customElements.define('deals-stack-component', DealsStackComponent);
}
